/* eslint-disable import/prefer-default-export */
import HomePageFirstImage from "../Assets/Images/Group1583.png";
import HomePageCloudImage from "../Assets/Images/Group1582.png";
import HomePageSolarHouseImage from "../Assets/Images/Image14.png";
import HomePageChartImageOne from "../Assets/Images/Chart1.png";
import HomePageChartImageTwo from "../Assets/Images/Chart2.png";
import HomePageChartImageThree from "../Assets/Images/Chart3.png";
import HomePageChartImagefour from "../Assets/Images/Chart4.png";
import HomePageSectionSixBackgroundImage from "../Assets/Images/Group1514.png";
import HomePageSectionSevenImage from "../Assets/Images/Testimonials.png";
import HomgePageDividerImage from "../Assets/Images/Group747.png";
import HomePageProjectImage1 from "../Assets/Images/projects/island_bay.jpg";
import HomePageProjectImage2 from "../Assets/Images/projects/johdphur.jpg";
import HomePageProjectImage3 from "../Assets/Images/projects/marsa-alam.jpg";
import HomePageProjectImage4 from "../Assets/Images/projects/namibia.jpg";
import HomePageProjectImage5 from "../Assets/Images/projects/pacific_resilience.jpg";
import HomePageProjectImage6 from "../Assets/Images/projects/pakaraka.png";
import HomePageProjectImage7 from "../Assets/Images/projects/te-papa.jpg";
import HomePageProjectImage8 from "../Assets/Images/projects/wainuiomata_marae.jpg";

export const AssetsImage = {
  HOMEPAGE_FIRST_IMAGE: HomePageFirstImage,
  HOMEPAGE_CLOUD_IMAGE: HomePageCloudImage,
  HOMEPAGE_SOLARHOME_IMAGE: HomePageSolarHouseImage,
  HOMEPAGE_CHART_ONE: HomePageChartImageOne,
  HOMEPAGE_CHART_TWO: HomePageChartImageTwo,
  HOMEPAGE_CHART_THREE: HomePageChartImageThree,
  HOMEPAGE_CHART_FOUR: HomePageChartImagefour,
  HOMEPAGE_SECTION_SIX_BACKGROUND_IMAGE: HomePageSectionSixBackgroundImage,
  HOMEPAGE_SECTION_SEVEN_IMAGE: HomePageSectionSevenImage,
  HOMEPAGE_DIVIDER_IMAGE: HomgePageDividerImage,
  HOMEPAGE_PROJECT_IMAGE1: HomePageProjectImage1,
  HOMEPAGE_PROJECT_IMAGE2: HomePageProjectImage2,
  HOMEPAGE_PROJECT_IMAGE3: HomePageProjectImage3,
  HOMEPAGE_PROJECT_IMAGE4: HomePageProjectImage4,
  HOMEPAGE_PROJECT_IMAGE5: HomePageProjectImage5,
  HOMEPAGE_PROJECT_IMAGE6: HomePageProjectImage6,
  HOMEPAGE_PROJECT_IMAGE7: HomePageProjectImage7,
  HOMEPAGE_PROJECT_IMAGE8: HomePageProjectImage8,
};

export const AssestsIcon = {
  ICON_DESIGN: "Icon_Design",
  ICON_EMPOWER: "Icon_Empower",
  ICON_DELIVER: "IconDeliver",
  ICON_HUMIDITY: "Humidity",
  ICON_REACTIVE_E1: "ReactiveEnergy1",
  ICON_TEMP: "Temperature",
  ICON_ACTIVE_E: "ActiveEnergy",
  ICON_ARROW_DOWN: "Arrow_down",
  ICON_ARROW_LEFT: "Arrow_Left",
  ICON_ARROW_RIGHT: "Arrow_Right",
  ICON_ARROW_UP: "Arrow_up",
  ICON_ARROW_BACK: "Back",
  ICON_BUILDING: "Building",
  ICON_CALENDER: "calendar",
  ICON_CUSTOMER: "Customer",
  ICON_DELETE: "Delete",
  ICON_DOWN_ARROW: "DownArrow",
  ICON_DOWNLOAD: "Download",
  ICON_FILTER: "Filter",
  ICON_BILLHISTORY: "Icon_BillHistory",
  ICON_FAQ: "Icon_FAQ",
  ICON_LOGOUT: "Icon_Logout",
  ICON_MAGAGEMETER: "Icon_ManageMeter",
  ICON_PASSWORD: "Icon_Password",
  ICON_PROFILE: "Icon_Profile",
  ICON_SETTINGS: "Icon_Settings",
  ICON_USER: "Icon_User",
  ICON_1: "Icon1",
  ICON_2: "Icon2",
  ICON_3: "Icon3",
  ICON_4: "Icon4",
  ICON_MENU: "Menu",
  ICON_NOTIFICATION: "Notification",
  ICON_PLUS: "Plus",
  ICON_REACTIVE_E: "ReactiveEnergy",
  ICON_STATUS_NOT_WOKING: "Status_notWorking",
  ICON_STATUS_WORKING: "Status_working",
  ICON_SUPPORT: "support",
  ICON_TICK: "Tick",
  ICON_TICKET: "Ticket",
  ICON_VIEWTICKET: "ViewTicket",
};

export const IconColors = {
  ICON_GREEN: "#007048",
  ICON_WHITE: "#FFFFFF",
  ICON_GRAY: "#0000009f",
  ICON_SKYBLUE: "#538dd5",
  ICON_BLACK: "#000000",
  ICON_LIGHT_GRAY: "#747474",
  ICON_RED: "#dd2020",
};
